import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import { ProjectReportsModel, ProjectReportsModelDTO, ProjectReportsQueryResponse} from './_models'
import fileDownload from 'js-file-download'
import { toast } from 'react-toastify';
import {
  getUploadFailureMessage,
  registerUploadFailureNotification,
  uploadFormDataInChunks,
} from 'app/modules/file-upload-page/core/uploadIntegrity'

const API_URL = "https://shifatr.org/api/project-report"

const getProjectReports = (query: string): Promise<ProjectReportsQueryResponse> => {
  return axios
    .get(`${API_URL}?${query}`)
    .then((d: AxiosResponse<ProjectReportsQueryResponse>) => d.data)
}

const getProjectReportById = (id: ID, userId:any, userRole:any): Promise<ProjectReportsModel | undefined> => {
  return axios
    .get(`${API_URL}/${id}`)
    .then((response: Response<ProjectReportsModel>) => response.data)
}

const getDownloadProjectReportFile = (id: ID): Promise<ProjectReportsModel | undefined> => {
  return axios
    .get(`${API_URL}/downloadfile/${id}`)
    .then((response: Response<ProjectReportsModel>) => response.data)
}

const downloadFileById = (id: any, fileName: any, intlnss?:any) => {
  toast.info(intlnss.formatMessage({ id: 'DOWNLOAD_STARTED' }), {
    autoClose: false // Bu seçenek mesajın otomatik olarak kapanmasını engeller.
});
  return axios({
    responseType: "blob",
    method: "GET",
    url: `${API_URL}/downloadfile/${id}`,
    params: {
      FileNameRequest: fileName,
    },
  }).then((response) => {
    if (response.data) {
      console.log("----------",response.data)
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      toast.dismiss();
      link.click();
    }
  }).catch((error)=>{
    toast.dismiss();
    if (error.response && error.response.status === 404) {
      toast.error(intlnss.formatMessage({ id: 'DOWNLOAD_FAILED' }), {
        autoClose: 5000,
      });
    } else {
      // Diğer hata durumları için genel hata mesajı
      toast.error(error, {
        autoClose: 5000,
      });
    }
  });
}


const createProjectReport = (ProjectReport: ProjectReportsModelDTO): Promise<ProjectReportsModelDTO | undefined> => {
  return axios
    .post(API_URL, ProjectReport)
    .then((response: Response<ProjectReportsModelDTO>) => response.data)
}

const updateProjectReport = (ProjectReport: ProjectReportsModelDTO): Promise<ProjectReportsModel | undefined> => {
  return axios
    .put(`${API_URL}`, ProjectReport)
    .then((response: Response<ProjectReportsModel>) => response.data)
}

const deleteProjectReport = (ProjectReportId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${ProjectReportId}`).then(() => {})
}

const deleteProjectReportFile = (ProjectReportId: ID, fileName: string): Promise<void> => {
  return axios
    .delete(`${API_URL}/deletefile/${ProjectReportId}`, { params: { fileName } })
    .then(() => {});
};


const getHelpPdf = (): any => {
  return axios
    .get(`${API_URL}/getHelpDocument`, {responseType: 'blob'})
    .then((d: any) => d.data)
}

const getChecklistAsPdf = (query: string) => {
  console.log(query)
  return axios({
    responseType: "blob",
    method: "GET",
    url: `${API_URL}/pdfreport?${query}`,
  }).then((response) => {
    fileDownload(response.data, "Report.pdf", "application/pdf");
  })
}

const getChecklistAsExcel = (query: string) => {
  return axios({
    responseType: "blob",
    method: "GET",
    url: `${API_URL}/excelreport?${query}`,
  }).then((response) => {
    fileDownload(response.data, "Report.xlsx");
  })
}

const createProjectReportsFileUpload = (file: FormData, fileName?:any, fileNameSecond?:any): Promise<Response<ID> | undefined> => {
  const fileFieldName = file.get('uploadedFile') ? 'uploadedFile' : 'addAttachments'
  const fileNameFieldName = fileFieldName === 'uploadedFile' ? 'fileName' : 'fileNameSecond'

  return uploadFormDataInChunks({
    completeUploadRequest: uploadComplete,
    fileNameFieldName,
    fileFieldName,
    formData: file,
    rollbackChunksRequest: rollbackChunks,
    uploadChunksRequest: uploadChunks,
  }).then((response: any) => ({
    ...response,
    data: response?.data?.value ?? response?.data,
  }))
  }

  const uploadChunks = (
    chunk: any,
    counter: number,
    fileName: string,
    options?: { expectedChunkSize?: number; uploadId?: string }
  ) => {
    const formData = new FormData();
    formData.append("chunk", chunk);
    formData.append("chunkNumber", counter.toString());
    formData.append("fileName", fileName);
    if (options?.expectedChunkSize !== undefined) {
      formData.append("expectedChunkSize", options.expectedChunkSize.toString());
    }
    if (options?.uploadId) {
      formData.append("uploadId", options.uploadId);
    }

    return axios.post(`${API_URL}/uploadChunks`, formData)
      .then((response: any) => response)
      .catch((error: any) => {
        registerUploadFailureNotification(getUploadFailureMessage(error))
        throw error
      });
  }

const rollbackChunks = (counter: number, fileName: string, uploadId?: string) => {
  const formData = new FormData();
  formData.append("id", counter.toString());
  formData.append("fileName", fileName);
  if (uploadId) {
    formData.append("uploadId", uploadId);
  }

  return axios.post(`${API_URL}/rollbackChunks`, formData)
    .then((response: any) => {
      return response
    })
    .catch((error: any) => {
      throw error
    });
}

  const uploadComplete = (file: any) => {
    return axios.post(`${API_URL}/uploadComplete`, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      if (response?.data?.isSuccess === false) {
        registerUploadFailureNotification(response?.data?.error)
      }

      return response
    }).catch((error) => {
      registerUploadFailureNotification(getUploadFailureMessage(error))
      throw error
    });
  }
export {getDownloadProjectReportFile, downloadFileById, deleteProjectReportFile,createProjectReportsFileUpload,getProjectReports, getProjectReportById, deleteProjectReport, createProjectReport, updateProjectReport, getChecklistAsPdf, getChecklistAsExcel, getHelpPdf, uploadChunks, rollbackChunks, uploadComplete}
